/**
 * The red telephone box, and the one piece of brand the site has. Drawn rather
 * than set as an emoji, because emoji render differently on every platform. It
 * reads at 28px because the window panes are the only interior detail.
 */
interface Props {
  /** Height in pixels. The box is drawn 4:5, so the width follows. */
  size: number;
}

export function BoothMark({ size }: Props) {
  return (
    <svg
      class="booth-mark"
      width={size * 0.8}
      height={size}
      viewBox="0 0 32 40"
      role="img"
      aria-label="A red telephone box"
    >
      <rect x="1" y="35" width="30" height="5" rx="1.5" fill="#8E241D" />
      <rect x="4" y="6" width="24" height="30" rx="2" fill="#C8332B" />
      <rect x="2.5" y="2.5" width="27" height="5" rx="1.5" fill="#A22820" />
      <rect x="13.5" y="0" width="5" height="3" rx="1" fill="#A22820" />
      <g fill="#F6E7DC">
        <rect x="7" y="10" width="8" height="6" rx="0.8" />
        <rect x="17" y="10" width="8" height="6" rx="0.8" />
        <rect x="7" y="18" width="8" height="6" rx="0.8" />
        <rect x="17" y="18" width="8" height="6" rx="0.8" />
        <rect x="7" y="26" width="8" height="6" rx="0.8" />
        <rect x="17" y="26" width="8" height="6" rx="0.8" />
      </g>
    </svg>
  );
}
